module.exports = __webpack_public_path__ + "media/images/footer-line-42c01b9ae6b7b77bf052389168dde981.svg";